import { DATE, TIME, DATETIME } from '@/plugins/sdk/fields'
import isString from 'lodash/isString'
import isDate from 'lodash/isDate'
import isArray from 'lodash/isArray'

export default {
  label: 'Is between',
  operator: 'is between',
  separator: ' and ',
  fields: [ DATE, TIME, DATETIME ],
  isValidValue (value) {
    if (isArray(value) && value.length === 2) {
      return isDate(new Date(value[0])) && isDate(new Date(value[1]))
    }

    if (isString(value)) {
      return value.length > 0
    }

    return false
  }
}
